import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Brand from '@/views/brand/Brand.vue'
import BrandDetail from '@/views/brand/BrandDetail.vue'
import Report from '@/views/report/Report.vue'
import ReportProgress from '@/views/report/ReportProgress.vue'
import Calendar from '@/views/calendar/Calendar.vue'
import PromotionDetail from '@/views/promotion/PromotionDetail.vue'
import Guard from '@/views/guard/Guard.vue'
import Verify from '@/views/guard/Verify.vue'
import DepartmentStore from '@/views/cooperation/DepartmentStore.vue'
import BrandApplication from '@/views/cooperation/BrandApplication.vue'
import DesignerApplication from '@/views/cooperation/DesignerApplication.vue'
import OfficerApplication from '@/views/cooperation/OfficerApplication.vue'
// import CooperationHome from '@/views/cooperation/CooperationHome.vue'
import CooperationCenter from '@/views/cooperation/CooperationCenter.vue'
// import EcoPortal from '@/views/portal/EcoPortal.vue'
import EcoPortal from '@/views/portal/EcoPortal1.vue'
import FAQ from '@/views/common/FAQ.vue'
import GuardHome from '@/views/guard/GuardHome.vue'
import DesignerProfile from '@/views/design/DesignerProfile.vue'
import GroupIntroduction from '@/views/portal/GroupIntroduction.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'ECO',
    component: EcoPortal
  },
  {
    path: '/authGuard',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/brand',
    name: 'Brand',
    component: Brand
  },
  {
    path: '/brand/detail',
    name: 'BrandDetail',
    component: BrandDetail
  },
  {
    path: '/report',
    name: 'Report',
    component: Report
  },
  {
    path: '/report/progress',
    name: 'ReportProgress',
    component: ReportProgress
  },
  // calendar
  {
    path: '/calendar',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/promotion/detail',
    name: 'PromotionDetail',
    component: PromotionDetail
  },
  {
    path: '/guard/home',
    name: 'GuardHome',
    component: GuardHome
  },
  {
    path: '/verification',
    name: 'Guard',
    component: Guard
  },
  {
    path: '/verify',
    name: 'Verify',
    component: Verify
  },
  {
    path: '/ecoPortal',
    name: 'EcoPortal',
    component: EcoPortal
  },
  {
    path: '/cooperationCenter',
    name: 'CooperationCenter',
    component: CooperationCenter
  },
  {
    path: '/cooperation/departmentStore',
    name: 'DepartmentStore',
    component: DepartmentStore
  },
  {
    path: '/cooperation/brandApplication',
    name: 'BrandApplication',
    component: BrandApplication
  },
  {
    path: '/cooperation/designerApplication',
    name: 'DesignerApplication',
    component: DesignerApplication
  },
  {
    path: '/cooperation/officerApplication',
    name: 'OfficerApplication',
    component: OfficerApplication
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/groupIntroduction',
    name: 'GroupIntroduction',
    component: GroupIntroduction
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/design/designerProfile',
    name: 'DesignerProfile',
    component: DesignerProfile
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 获取URL参数函数
function getUrlParam (name: string): string | null {
  const urlParams = new URLSearchParams(window.location.search)
  console.log('222', urlParams)
  return urlParams.get(name)
}

// 语言检测和设置函数
function detectAndSetLanguage (urlLang: string): void {
  // 检查URL参数
  // const urlLang = getUrlParam('lang')
  console.log('1111', urlLang)
  if (urlLang) {
    let locale = ''

    if (urlLang === 'zh') {
      locale = 'zh-CN'
    } else if (urlLang === 'en') {
      locale = 'en-US'
    }

    if (locale) {
      // 更新本地存储
      localStorage.setItem('userLang', locale)

      // 如果i18n实例存在，更新语言
      const i18n = (window as any).$i18n
      if (i18n && i18n.locale !== locale) {
        i18n.locale = locale
      }

      console.log(`Language set to ${locale} from URL parameter`)
    }
  }
}

// 在路由导航前检测语言
router.beforeEach((to, from, next) => {
  // 检测并设置语言
  // detectAndSetLanguage()
  const lang = to.query.lang as string
  detectAndSetLanguage(lang)
  next()
})

// 初始加载时也检测一次
// detectAndSetLanguage()

export default router
